import { Navigate } from "react-router-dom";

const PrivateRouteReservation = ({ children }) => {
  const token = localStorage.getItem("ReservationAuthToken");
  const authType = localStorage.getItem("authType");
  return token && authType === "reservation" ? children : <Navigate to="/Reservation/login" />;
};

export default PrivateRouteReservation;
